import PropTypes from 'prop-types';
import PulseLoader from 'react-spinners/PulseLoader';

// TODO: Add third button variant for Apaleo Check out App

const Button = ({
  text,
  variant,
  disabled = false,
  loading = false,
  type = 'button',
  onClick = () => {},
  extraPadding = false,
  zeroPadding = false,
  semibold = false,
  small = false,
  leftIcon,
}) => {
  let bgColor;
  let textColor;
  let border;
  let hover;
  let active;
  const enabled = !disabled;

  if (enabled) {
    hover = 'hover:scale-[102%]';

    if (!loading) {
      active = 'active:translate-y-1';
    }

    if (variant === 'primary') {
      bgColor = 'bg-pj-primary-400';
      border = 'border-4 border-pj-primary-400';
      textColor = 'text-pj-good-contrast';
    }

    if (variant === 'secondary') {
      bgColor = 'bg-pj-gray-300';
      border = 'border-4 border-pj-primary-400';
      textColor = 'text-pj-primary-400';
    }

    if (variant === 'dark') {
      bgColor = 'bg-white';
      border = 'border-4 border-[#626161]';
      textColor = 'text-[#626161]';
    }

    if (variant === 'transparent') {
      bgColor = 'transparent';
      textColor = 'text-pj-primary-400';
    }
  }

  if (disabled || loading) {
    if (variant === 'primary') {
      bgColor = 'bg-pj-gray-500';
      border = 'border-4 border-pj-gray-500';
      textColor = 'text-pj-gray-700';
    }

    if (variant === 'secondary') {
      bgColor = 'bg-pj-gray-400';
      border = 'border-4 border-pj-gray-600';
      textColor = 'text-pj-gray-700';
    }

    if (variant === 'dark') {
      bgColor = 'bg-white';
      border = 'border-4 border-pj-gray-600';
      textColor = 'text-pj-gray-600';
    }

    if (variant === 'transparent') {
      bgColor = 'transparent';
      textColor = 'text-pj-gray-600';
    }
  }

  if (disabled) {
    hover = 'cursor-not-allowed';
  }

  if (loading) {
    hover = 'cursor-wait';
  }

  return (
    <button
      className={`flex w-full flex-1 select-none items-center justify-center gap-3 rounded-md px-5 duration-200 ${semibold ? 'font-semibold' : 'font-bold'} ${small ? 'text-sm' : 'text-xl'} ${extraPadding ? 'py-3' : 'py-1'} ${zeroPadding && '!p-0'} ${textColor} ${bgColor} ${border} ${hover} ${active}`}
      type={type}
      onClick={onClick}
      disabled={disabled || loading}
    >
      <PulseLoader
        color="#c0c0c0"
        loading={loading}
        size={12}
        speedMultiplier={0.6}
        cssOverride={{ display: 'block', margin: 'auto auto' }}
      />

      {!loading && (
      <div className="flex justify-center gap-2">
        <span>{leftIcon}</span>
        <span>{text}</span>
      </div>
      )}
    </button>
  );
};

Button.propTypes = {
  variant: PropTypes.oneOf(['primary', 'secondary', 'dark', 'transparent'])
    .isRequired,
  text: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  loading: PropTypes.bool,
  type: PropTypes.oneOf(['button', 'reset', 'submit']),
  onClick: PropTypes.func,
  extraPadding: PropTypes.bool,
  zeroPadding: PropTypes.bool,
  semibold: PropTypes.bool,
  small: PropTypes.bool,
  leftIcon: PropTypes.node,
};

export default Button;
